import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {CoreRoutingModule} from '@core/core-routing.module';
import {MaterialModule} from '@core/material/material.module';
import {FooterComponent} from '@core/components/footer/footer.component';
import {HeaderComponent} from '@core/components/header/header.component';
import {MainComponent} from '@core/components/main/main.component';
import {TemplateComponent} from '@core/components/template/template.component';
import {BreadcrumbComponent} from '@core/components/breadcrumb/breadcrumb.component';


@NgModule({
  declarations: [
    FooterComponent,
    HeaderComponent,
    MainComponent,
    TemplateComponent,
    BreadcrumbComponent
  ],
  exports: [
    TemplateComponent,
    BreadcrumbComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    CoreRoutingModule,
    MaterialModule
  ]
})
export class CoreModule {
}
